import React, { useState } from "react";
import { Lock, BookOpen } from "lucide-react";
import { API } from "../lib/api";

const SAMPLES = [
  { page: 1, label: "Cover", blurred: false },
  { page: 2, label: "Birth Signature", blurred: true },
  { page: 3, label: "Sun, Moon & Rising", blurred: true },
];

// Blurred 3-page sample of the shopper's own report, rendered server-side.
export default function BlueprintPreview({ onUnlock, busy }) {
  const [open, setOpen] = useState(null);
  const src = (p) => `${API}/users/natal-blueprint/preview.png?page=${p}`;

  return (
    <div className="relative mt-5 pt-5 border-t border-white/10" data-testid="blueprint-preview">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="text-[9px] uppercase tracking-[0.3em] text-[#C8A96E] flex items-center gap-1.5">
          <BookOpen size={11} /> Preview your report · 3 of 21 pages
        </div>
        <div className="text-[9px] uppercase tracking-[0.2em] text-[#A89C98]">Generated from your chart</div>
      </div>
      <div className="grid grid-cols-3 gap-2 sm:gap-3">
        {SAMPLES.map((s) => (
          <button
            key={s.page}
            type="button"
            onClick={() => setOpen(s)}
            data-testid={`blueprint-preview-page-${s.page}`}
            className="group relative overflow-hidden rounded-lg border border-[#C8A96E]/30 bg-black/40 aspect-[210/297] text-left focus:outline-none focus:ring-2 focus:ring-[#C8A96E]/60"
          >
            <img src={src(s.page)} alt={`Blueprint page ${s.page} — ${s.label}`} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
            {s.blurred && (
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="inline-flex items-center gap-1 px-2 py-1 rounded bg-[#15111A]/80 border border-[#C8A96E]/50 text-[9px] uppercase tracking-[0.2em] text-[#C8A96E]">
                  <Lock size={10} /> Locked
                </span>
              </div>
            )}
            <div className="absolute inset-x-0 bottom-0 px-2 py-1.5 bg-gradient-to-t from-[#15111A] to-transparent text-[9px] uppercase tracking-[0.2em] text-[#E8DFD3]">
              p.{s.page} · {s.label}
            </div>
          </button>
        ))}
      </div>
      <p className="text-[11px] text-[#A89C98] mt-3">
        Plus 18 more pages: 9 planetary-line chapters, your Money / Love / Healing cities, an 8-day wellness journey and your 12-month outlook.
      </p>

      {open && (
        <div
          className="fixed inset-0 z-50 bg-black/85 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setOpen(null)}
          data-testid="blueprint-preview-lightbox"
        >
          <div className="relative max-h-[90vh] max-w-[92vw]" onClick={(e) => e.stopPropagation()}>
            <img src={src(open.page)} alt={`Blueprint page ${open.page}`} className="max-h-[78vh] w-auto rounded-lg border border-[#C8A96E]/40 shadow-2xl" />
            <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#E8DFD3]">Page {open.page} of 21 · {open.label}</div>
              {open.blurred && onUnlock && (
                <button
                  onClick={onUnlock}
                  disabled={busy}
                  data-testid="blueprint-preview-unlock-btn"
                  className="inline-flex items-center gap-2 h-9 px-4 uppercase tracking-widest text-[11px] font-bold bg-[#C8A96E] text-[#15111A] hover:bg-[#A98B55] transition-colors"
                >
                  <Lock size={12} /> {busy ? "Opening checkout…" : "Unlock all 21 pages · $4.40"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
